import { FlexBox } from "@brg/ui";
import { FC, useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next";
import { AgreeWrapper } from "shared/modals/styles";
import { MagicBoxRow } from "shared/pages/project/components/toolsStyles";
import { AppTester } from "supporting";


export const AgreeBlock: FC<{ onCheck: (flag: boolean, data: any) => void, competitionId?: string, extraCheckboxs?: boolean }> = ({ onCheck, competitionId, extraCheckboxs }) => {
    const isDamuseum = AppTester.isDaMuseum();
    const isGeo = AppTester.isGeograffee();
    const isCompetition = AppTester.isCompetition();
    const { i18n: {language} } = useTranslation();

    const isVKCompetition = useMemo(
        () => competitionId ? (competitionId === '03df63848cc24f0a860a2a4143f63a58') : undefined , [competitionId])

    const [agreeData, setAgreeData] = useState({
        agreeOne: false,
        agreeTwo: false,
        ...(isDamuseum && {
            agreeThree: false,
            agreeFour: false,
            agreeFive: false,
            agreeSix: false,
            agreeSeven: false,
        })
    });

    useEffect(() => {
        if (Object?.values(agreeData)?.every((value) => !!value)) {
            onCheck(true, agreeData)
        } else {
            onCheck(false, agreeData)
        }
    }, [agreeData, onCheck])

    const handleAgreeDataChange = (type: string, value: boolean) => {
        setAgreeData({...agreeData, [type]: value})
    }

    const agreementDocumentRoute = 'https://www.hse.ru/data_protection_regulation';
    const personalDataDocumentRoute = useMemo(() => {
        return (
            isGeo ? ( language === 'ru' ? process.env.REACT_APP_URL_GEOGRAPHY_RU 
                : process.env.REACT_APP_URL_GEOGRAPHY_EN)
            : isCompetition ? process.env.REACT_APP_URL_DEZIIIGN : 
            ( language === 'ru' ? process.env.REACT_APP_URL_HSEDESIGN_RU 
            : process.env.REACT_APP_URL_HSEDESIGN_EN) ) + '/legals';
    }, [language, isGeo, isCompetition])

    const agreementVKroute = 'https://cloud.mail.ru/public/WKsy/TBiAUF6oR';

    return useMemo(() => {
        return (
            <AgreeWrapper>
                {isDamuseum ? (
                    <>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeOne}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeOne', !agreeData?.agreeOne)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Подтверждаю, что ознакомлен (-на) и согласен (-на) с Положением о Конкурсе ВМДПНИ</span>
                            ) : (
                                <span>I confirm that I have read and agree with the Regulations on the VMDPNI Competition</span>
                            )}
                        </FlexBox>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeTwo}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeTwo', !agreeData?.agreeTwo)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Подтверждаю, что ознакомлен (-на) и согласен (-на) с публичной офертой.</span>
                            ) : (
                                <span>I confirm that I have read and agree to the public offer.</span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData?.agreeThree}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeThree', !agreeData?.agreeThree)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Подтверждаю, что введенная информация об авторах полная и достоверная, а также что имею право на участие в конкурсе.</span>
                            ) : (
                                <span>I confirm that the information entered about the authors is complete and reliable, and that I am eligible to participate in the competition.</span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData.agreeFour}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeFour', !agreeData?.agreeFour)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Согласен на обработку персональных данных в соответствии с п. 20.1. Положения о Конкурсе.</span>
                            ) : (
                                <span>I agree to the processing of personal data in accordance with clause 20.1. of the Competition Regulations.</span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData?.agreeFive}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeFive', !agreeData?.agreeFive)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                            ) : (
                                <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData?.agreeSix}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeSix', !agreeData?.agreeSix)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                            ) : (
                                <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData?.agreeSeven}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeSeven', !agreeData?.agreeSeven)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Обязуюсь оплатить регистрационный сбор до 12 августа 2024 года по ссылке (для участников РФ) <a href={'https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B'} target={'_BLANK'}>https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B</a> / на расчетный счет в рублях (для участников СНГ).</span>
                            ) : (
                                <span>I undertake to pay the registration fee by August 12, 2024 at the link (for participants of the Russian Federation)<a href={'https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B'} target={'_BLANK'}></a> / to a current account in rubles (for CIS members).</span>
                            )}
                        </FlexBox>
                    </>
                ) : extraCheckboxs ? (
                    <>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeOne}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeOne', !agreeData?.agreeOne)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я даю согласие на обработку персональных данных в порядке и на условиях <a href={'https://docs.google.com/document/d/1N7KT-okj1JofL6qQNV5g889D5QJ2fmELY9CYwTLqfRQ/pub'} target={'_BLANK'}>Политики обработки персональных данных</a> </span>
                            ) : (
                                <span>
                                    I consent to the processing of personal data in the manner and under<a href={'https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B'} target={'_BLANK'}>the conditions</a> <a href={'https://docs.google.com/document/d/1N7KT-okj1JofL6qQNV5g889D5QJ2fmELY9CYwTLqfRQ/pub'} target={'_BLANK'}>Personal data processing policies</a></span>
                            )}
                        </FlexBox>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeTwo}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeTwo', !agreeData?.agreeTwo)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я принимаю условия <a href={'https://docs.google.com/document/d/1kLkssEpLyb6iHjXmlzqj9JUSsSW6DG8V/pub'} target={'_BLANK'}>Лицензионного соглашения</a> и  <a href={'https://docs.google.com/document/d/1mLQIX4iH300bj2dubBw61Y0CwyYDqbIw3ta-MjV6IL4/pub'} target={'_BLANK'}>Положение о конкурсе</a></span>
                            ) : (
                                <span>I accept the terms of <a href={'https://docs.google.com/document/d/1kLkssEpLyb6iHjXmlzqj9JUSsSW6DG8V/pub'} target={'_BLANK'}>the License Agreement</a> and <a href={'https://docs.google.com/document/d/1mLQIX4iH300bj2dubBw61Y0CwyYDqbIw3ta-MjV6IL4/pub'} target={'_BLANK'}>Regulations on the competition</a> </span>
                            )}
                        </FlexBox>
                    </>
                ) : (
                    <>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeOne}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeOne', !agreeData?.agreeOne)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                            ) : (
                                <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                            )}
                        </FlexBox>
                        <FlexBox direction='row' offsetTop={24} align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeTwo}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeTwo', !agreeData?.agreeTwo)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                            ) : (
                                <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                            )}
                        </FlexBox>
                        {isVKCompetition && (
                            <FlexBox direction='row' align='center' offsetTop={24}>
                                <MagicBoxRow
                                    className={'checkbox'}
                                    checked={agreeData?.agreeThree || false}
                                    label={''}
                                    onClick={() => handleAgreeDataChange('agreeThree', !agreeData?.agreeThree)}
                                    isTeamEdit
                                />
                                {language === 'ru' ? (
                                    <span>Я соглашаюсь с <a href={agreementVKroute} target={'_BLANK'}>Положением о конкурсе</a></span>
                                ) : (
                                    <span>I agree to the <a href={agreementVKroute} target={'_BLANK'}>Regulations on the competition</a></span>
                                )}
                            </FlexBox>
                        )}
                    </>
                )}
            </AgreeWrapper>
        )
    } , [agreeData, handleAgreeDataChange, isDamuseum, language, isVKCompetition, agreementVKroute, personalDataDocumentRoute])
}import { FlexBox } from "@brg/ui";
import { FC, useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next";
import { AgreeWrapper } from "shared/modals/styles";
import { MagicBoxRow } from "shared/pages/project/components/toolsStyles";
import { AppTester } from "supporting";


export const AgreeBlock: FC<{ onCheck: (flag: boolean, data: any) => void, competitionId?: string, extraCheckboxs?: boolean }> = ({ onCheck, competitionId, extraCheckboxs }) => {
    const isDamuseum = AppTester.isDaMuseum();
    const isGeo = AppTester.isGeograffee();
    const isCompetition = AppTester.isCompetition();
    const { i18n: {language} } = useTranslation();

    const isVKCompetition = useMemo(
        () => competitionId ? (competitionId === '03df63848cc24f0a860a2a4143f63a58') : undefined , [competitionId])

    const [agreeData, setAgreeData] = useState({
        agreeOne: false,
        agreeTwo: false,
        ...(isDamuseum && {
            agreeThree: false,
            agreeFour: false,
            agreeFive: false,
            agreeSix: false,
            agreeSeven: false,
        })
    });

    useEffect(() => {
        if (Object?.values(agreeData)?.every((value) => !!value)) {
            onCheck(true, agreeData)
        } else {
            onCheck(false, agreeData)
        }
    }, [agreeData, onCheck])

    const handleAgreeDataChange = (type: string, value: boolean) => {
        setAgreeData({...agreeData, [type]: value})
    }

    const agreementDocumentRoute = 'https://www.hse.ru/data_protection_regulation';
    const personalDataDocumentRoute = useMemo(() => {
        return (
            isGeo ? ( language === 'ru' ? process.env.REACT_APP_URL_GEOGRAPHY_RU 
                : process.env.REACT_APP_URL_GEOGRAPHY_EN)
            : isCompetition ? process.env.REACT_APP_URL_DEZIIIGN : 
            ( language === 'ru' ? process.env.REACT_APP_URL_HSEDESIGN_RU 
            : process.env.REACT_APP_URL_HSEDESIGN_EN) ) + '/legals';
    }, [language, isGeo, isCompetition])

    const agreementVKroute = 'https://cloud.mail.ru/public/WKsy/TBiAUF6oR';

    return useMemo(() => {
        return (
            <AgreeWrapper>
                {isDamuseum ? (
                    <>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeOne}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeOne', !agreeData?.agreeOne)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Подтверждаю, что ознакомлен (-на) и согласен (-на) с Положением о Конкурсе ВМДПНИ</span>
                            ) : (
                                <span>I confirm that I have read and agree with the Regulations on the VMDPNI Competition</span>
                            )}
                        </FlexBox>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeTwo}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeTwo', !agreeData?.agreeTwo)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Подтверждаю, что ознакомлен (-на) и согласен (-на) с публичной офертой.</span>
                            ) : (
                                <span>I confirm that I have read and agree to the public offer.</span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData?.agreeThree}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeThree', !agreeData?.agreeThree)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Подтверждаю, что введенная информация об авторах полная и достоверная, а также что имею право на участие в конкурсе.</span>
                            ) : (
                                <span>I confirm that the information entered about the authors is complete and reliable, and that I am eligible to participate in the competition.</span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData.agreeFour}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeFour', !agreeData?.agreeFour)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Согласен на обработку персональных данных в соответствии с п. 20.1. Положения о Конкурсе.</span>
                            ) : (
                                <span>I agree to the processing of personal data in accordance with clause 20.1. of the Competition Regulations.</span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData?.agreeFive}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeFive', !agreeData?.agreeFive)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                            ) : (
                                <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData?.agreeSix}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeSix', !agreeData?.agreeSix)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                            ) : (
                                <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                            )}
                        </FlexBox>

                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                //@ts-ignore
                                checked={agreeData?.agreeSeven}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeSeven', !agreeData?.agreeSeven)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Обязуюсь оплатить регистрационный сбор до 12 августа 2024 года по ссылке (для участников РФ) <a href={'https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B'} target={'_BLANK'}>https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B</a> / на расчетный счет в рублях (для участников СНГ).</span>
                            ) : (
                                <span>I undertake to pay the registration fee by August 12, 2024 at the link (for participants of the Russian Federation)<a href={'https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B'} target={'_BLANK'}></a> / to a current account in rubles (for CIS members).</span>
                            )}
                        </FlexBox>
                    </>
                ) : extraCheckboxs ? (
                    <>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeOne}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeOne', !agreeData?.agreeOne)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я даю согласие на обработку персональных данных в порядке и на условиях <a href={'https://docs.google.com/document/d/1N7KT-okj1JofL6qQNV5g889D5QJ2fmELY9CYwTLqfRQ/pub'} target={'_BLANK'}>Политики обработки персональных данных</a> </span>
                            ) : (
                                <span>
                                    I consent to the processing of personal data in the manner and under<a href={'https://tickets.damuseum.ru/event/18BD9CE4FB788F27FEDC515F652E2A2165D5CC9B'} target={'_BLANK'}>the conditions</a> <a href={'https://docs.google.com/document/d/1N7KT-okj1JofL6qQNV5g889D5QJ2fmELY9CYwTLqfRQ/pub'} target={'_BLANK'}>Personal data processing policies</a></span>
                            )}
                        </FlexBox>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeTwo}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeTwo', !agreeData?.agreeTwo)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я принимаю условия <a href={'https://docs.google.com/document/d/1kLkssEpLyb6iHjXmlzqj9JUSsSW6DG8V/pub'} target={'_BLANK'}>Лицензионного соглашения</a> и  <a href={'https://docs.google.com/document/d/1mLQIX4iH300bj2dubBw61Y0CwyYDqbIw3ta-MjV6IL4/pub'} target={'_BLANK'}>Положение о конкурсе</a></span>
                            ) : (
                                <span>I accept the terms of <a href={'https://docs.google.com/document/d/1kLkssEpLyb6iHjXmlzqj9JUSsSW6DG8V/pub'} target={'_BLANK'}>the License Agreement</a> and <a href={'https://docs.google.com/document/d/1mLQIX4iH300bj2dubBw61Y0CwyYDqbIw3ta-MjV6IL4/pub'} target={'_BLANK'}>Regulations on the competition</a> </span>
                            )}
                        </FlexBox>
                    </>
                ) : (
                    <>
                        <FlexBox direction='row' align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeOne}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeOne', !agreeData?.agreeOne)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я соглашаюсь с <a href={personalDataDocumentRoute} target={'_BLANK'}>Пользовательским соглашением</a> ресурсов hsedesign.com и hsedesign.ru</span>
                            ) : (
                                <span>I agree to the <a href={personalDataDocumentRoute} target={'_BLANK'}>User Agreement</a> of the resources hsedesign.com and hsedesign.ru</span>
                            )}
                        </FlexBox>
                        <FlexBox direction='row' offsetTop={24} align='center'>
                            <MagicBoxRow
                                className={'checkbox'}
                                checked={agreeData?.agreeTwo}
                                label={''}
                                onClick={() => handleAgreeDataChange('agreeTwo', !agreeData?.agreeTwo)}
                                isTeamEdit
                            />
                            {language === 'ru' ? (
                                <span>Я соглашаюсь с <a href={agreementDocumentRoute} target={'_BLANK'}>Политикой конфиденциальности и обработки персональных данных</a></span>
                            ) : (
                                <span>I agree to <a href={agreementDocumentRoute} target={'_BLANK'}>the Privacy and Personal Data Processing Policy</a></span>
                            )}
                        </FlexBox>
                        {isVKCompetition && (
                            <FlexBox direction='row' align='center' offsetTop={24}>
                                <MagicBoxRow
                                    className={'checkbox'}
                                    checked={agreeData?.agreeThree || false}
                                    label={''}
                                    onClick={() => handleAgreeDataChange('agreeThree', !agreeData?.agreeThree)}
                                    isTeamEdit
                                />
                                {language === 'ru' ? (
                                    <span>Я соглашаюсь с <a href={agreementVKroute} target={'_BLANK'}>Положением о конкурсе</a></span>
                                ) : (
                                    <span>I agree to the <a href={agreementVKroute} target={'_BLANK'}>Regulations on the competition</a></span>
                                )}
                            </FlexBox>
                        )}
                    </>
                )}
            </AgreeWrapper>
        )
    } , [agreeData, handleAgreeDataChange, isDamuseum, language, isVKCompetition, agreementVKroute, personalDataDocumentRoute])
}